export default __webpack_public_path__ + "videos/about-us-video--animation.mp4?74a1808c19a2cda5f2d30300d70ba9b4";